<mat-sidenav-container class="h-screen">
  <mat-sidenav #drawer class="sidenav" fixedInViewport
               [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
               [mode]="(isHandset$ | async) ? 'over' : 'side'"
               [opened]="(isHandset$ | async) === false">

    <!-- Sidenav Header -->
    <mat-toolbar class="sidenav-header">
      <span class="brand-title">{{ 'app-title' | translate }}</span>
    </mat-toolbar>

    <div class="px-2">
      <!-- Navigation Menu -->
      <mat-nav-list>
        @for (item of navigationItems; track item.route) {
          <a mat-list-item
             [routerLink]="item.route"
             routerLinkActive #rla="routerLinkActive"
             [activated]="rla.isActive">
            <mat-icon matListItemIcon>{{ item.icon }}</mat-icon>
            {{ item.labelKey | translate }}
          </a>
        }
      </mat-nav-list>
    </div>

  </mat-sidenav>

  <mat-sidenav-content class="!flex flex-col">
    <!-- Top Toolbar -->
    <mat-toolbar color="primary">
      @if (isHandset$ | async) {
        <button
          type="button"
          [attr.aria-label]="'nav.toggle-sidenav' | translate"
          mat-icon-button
          (click)="drawer.toggle()">
          <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
        </button>
      }

      <span>{{ 'nav.admin-panel' | translate }}</span>

      <!-- User Menu -->
      <div class="ml-auto">
      <button mat-icon-button [matMenuTriggerFor]="userMenu" [attr.aria-label]="'nav.user-menu' | translate">
        <mat-icon>account_circle</mat-icon>
      </button>
      <mat-menu #userMenu="matMenu">
        <button mat-menu-item (click)="logout()">
          <mat-icon>logout</mat-icon>
          <span>{{ 'nav.logout' | translate }}</span>
        </button>
      </mat-menu>
    </div>
    </mat-toolbar>

    <!-- Main Content Area -->
    <div class="flex-1 overflow-auto p-4">
      <router-outlet />
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
